import { secondAuthenticateProxy } from './index';

//2차인증 - 인증코드 전송
function sendSecondAuthenticate(params) {
  return secondAuthenticateProxy.get('api/api/second-authenticate', { params });
}
//2차인증 - 인증코드 확인
function validSecondAuthenticate(params) {
  return secondAuthenticateProxy.post('api/api/second-authenticate', params);
}
//2차인증 - 인증여부 확인
function checkSecondAuthenticate(params) {
  return secondAuthenticateProxy.post(
    'api/api/second-authenticate-check',
    params,
  );
}

export {
  sendSecondAuthenticate,
  validSecondAuthenticate,
  checkSecondAuthenticate,
};
